module.exports = __webpack_public_path__ + "static/7-laura-ec82f449a5c8b5d35957d5514b432eb2.jpg";